module.exports = __webpack_public_path__ + "static/media/Photo - Azentio-Lana.8ff8aeef.jpg";